'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	var removeEmptyList = function removeEmptyList() {
		if ($('.js-removeEmpty').length) {
			$('.js-removeEmpty').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).remove();
				}
			});
		}
	};
	var removeParentEmptyList = function removeParentEmptyList() {
		if ($('.js-removeEmptyParent').length) {
			$('.js-removeEmptyParent').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-removeEmptyParent-parent').remove();
				}
			});
		}
	};

	var slider = function slider() {
		if ($('.mod-slider01').length) {
			$('.mod-slider01').slick({
				autoplay: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				loop: true,
				arrows: true,
				dots: false,
				speed: 300,
				prevArrow: '<button class="mod-slider-prev"><i class="icon icon-arrow_left"></i></button>',
				nextArrow: '<button class="mod-slider-next"><i class="icon icon-arrow_right"></i></button>',
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}]
			});
			var imgHeight = $('.mod-box01 img').eq(1).outerHeight(true);
			var arrowHeight = $('.mod-slider01 .slick-arrow').eq(1).height();
			var arrowPosition = imgHeight / 2 - arrowHeight / 2;
			$('.mod-slider01 .slick-arrow').css('top', arrowPosition);
		}
	};

	var animation = function animation() {
		// フェードインアニメーション
		if ($('.js-inview').length) {
			$('.js-inview').waypoint(function (direction) {
				var activePoint = $(this.element);
				activePoint.addClass(a);
			}, { offset: '70%' });
		}
		if ($('.js-inview-fade').length) {
			$('.js-inview-fade').waypoint(function (direction) {
				var activePoint = $(this.element);
				if (direction === 'down') {
					//scroll down
					activePoint.addClass(a);
				} else {
					//scroll up
					activePoint.removeClass(a);
				}
			}, { offset: '70%' });
		}
		// 左からアニメーション
		if ($('.js-inview-bottom').length) {
			$('.js-inview-bottom').waypoint(function (direction) {
				var activePoint = $(this.element);
				if (direction === 'down') {
					//scroll down
					activePoint.addClass(a);
				} else {
					//scroll up
					activePoint.removeClass(a);
				}
			}, { offset: '70%' });
		}
		// 文字背景アニメーション
		if ($('.js-text-anime').length) {
			$('.js-text-anime').waypoint(function (direction) {
				var activePoint = $(this.element);
				if (direction === 'down') {
					//scroll down
					activePoint.addClass(a);
				} else {
					//scroll up
					activePoint.removeClass(a);
				}
			}, { offset: '70%' });
		}
	};

	removeEmptyList();
	removeParentEmptyList();
	slider();
	animation();
})(window.jQuery, window.FUNCTIONS);